module.exports = __webpack_public_path__ + "media/images/malvinas/covid19_rules.orig-89b80145ecf949f28f668e294f79b6ef.svg";